// eslint-disable-next-line import/prefer-default-export
export function playNotificationSound(times = 1, delay = 1000) {
  const sound = new Audio('/ringtone.mp3');

  if (times > 0) {
    sound.play();
    setTimeout(() => playNotificationSound(times - 1, delay), delay);
  }
}
